import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { Typography, Paper, Box, Container, Chip, Divider, Alert, MenuItem, TextField, Stack } from '@mui/material';
import { MessageToastLogin } from '../../Generic';
import { replace } from 'connected-react-router';
import { handleSelectClientAction } from '../actions/loginActions';
import { getTranslate } from 'react-localize-redux';
import PlaceholderIMG from '../../../assets/images/placeholder.svg';
import MadeBy from '../MadeBy';
import { setActiveLanguage, getActiveLanguage, getLanguages } from 'react-localize-redux';
import BankID from '../../Generic/BankID';
import LoginBankID from '../LoginBankID';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const Invitation = ({ settings, config, translate, ...props }) => {
	const location = useLocation();
	const [ isConfirmed, setIsConfirmed ] = useState(false);
	const dispatch = useDispatch();
	const { client, token_invite } = useParams();

	useEffect(() => {
		if (client) {
			const selectedClient = settings.clients.find((item) => item.short_name === client);
			dispatch(handleSelectClientAction(selectedClient, 'frontoffice'));
		} else {
			dispatch(handleSelectClientAction(null, 'frontoffice'));
		}
	}, [client]);

	return (
		<Container maxWidth={false} disableGutters>
			<div className={'welcome-presentation-content'}>
				<Box
					sx={{
						position: { xs: 'relative', md: 'fixed' },
						top: 30,
						left: { md: 30 },
						zIndex: 1000,
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'flex-start',
					}}
				>
					<img
						src={
							settings?.site?.files?.navbar_logo
								? `${config.apihost}/configuration/files/${settings.site.files.navbar_logo.uuid}`
								: PlaceholderIMG
						}
						height="50"
						alt="Alteri's logo"
					/>
					<Typography variant="caption" color="secondary" sx={{ mt: 1 }}>
						{translate('register_invite_logo_subtitle')}
					</Typography>
				</Box>

				<Box
					sx={{
						position: { xs: 'static', md: 'absolute' },
						right: { md: '5%' },
						top: { md: '45%' },
						transform: { md: 'translateY(-50%)' },
						width: { xs: '90%', sm: '70%', md: '25%' },
						mt: { xs: 5 },
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
					}}
				>
					<Paper elevation={3} className="login-content-right-content-tabs">
						<Typography variant="h6" fontWeight="bold">
							{props.client?.name
								? translate('register_invite_with_client_selected', { name: props.client.name })
								: translate('register_invite_no_client_selected')}
						</Typography>
						<Typography variant="body1">{translate('register_invite_subtitle')}</Typography>
						<Divider sx={{ mt: 1 }} />
						<MessageToastLogin />
						{props.message && props.message.length > 0 && (
							<Box sx={{ mt: 1 }}>
								<Alert severity="warning">{props.message}</Alert>
							</Box>
						)}
						<Box mt={3}>
							<Stack spacing={1} direction="column" alignItems="center">
								{isConfirmed && <CheckCircleOutlineIcon color={'success'} />}
								{isConfirmed ? (
									<Typography align="justify" variant="subtitle2" component="p">
										{translate('register_invite_confirmed_description')}
									</Typography>
								) : (
									<LoginBankID token_invite={token_invite} callback={() => setIsConfirmed(true)} />
								)}
							</Stack>
						</Box>
						{!isConfirmed && props.languages.length > 1 && (
							<Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
								<TextField
									select
									label={translate('generic_select')}
									value={props.currentLanguage?.code || ''}
									onChange={(e) => dispatch(setActiveLanguage(e.target.value))}
									helperText={translate('register_invite_select_preferred_language')}
									margin="normal"
									variant="outlined"
									sx={{ width: 250 }}
								>
									{props.languages.map((option) => (
										<MenuItem key={option.code} value={option.code}>
											{translate('language_' + option.label)}
										</MenuItem>
									))}
								</TextField>
							</Box>
						)}
						<Box mt={1}>
							<MadeBy />
						</Box>
					</Paper>
				</Box>
			</div>
		</Container>
	);
};

const mapStateToProps = (state) => ({
	translate: getTranslate(state.localize),
	settings: state.settings,
	client: state.login.client,
	login: state.login.login,
	query: state.router.location?.query,
	config: state.config,
	message: state.login.message,
	currentLanguage: getActiveLanguage(state.localize),
	languages: getLanguages(state.localize).filter((test) => test.code !== 'raw'),
});

export default connect(mapStateToProps, { handleSelectClientAction })(Invitation);
